import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaInformacionPrincipalComponent {
  empresaId = undefined
  aceptar = false
  regimenFiscal = {}
  regimenCopia = {}
  data = {
    razon_social: null,
    rfc: null,
    regimen_fiscal_id: undefined,
    empresa_interna: false,
    clave_contribuyente: null,
  }

  constructor($q, EmpresaInformacionPrincipal, EmpresaCatalogoRegimenFiscal) {
    this.$q = $q
    this.EmpresaCatalogoRegimenFiscalService = EmpresaCatalogoRegimenFiscal
    this.EmpresaInformacionPrincipalService = EmpresaInformacionPrincipal
  }

  $onInit() {
    this.promise = this.$q.all([
      this.EmpresaCatalogoRegimenFiscalService.get().then((response) => {
        this.regimenFiscal = response.data
        this.regimenCopia = this.regimenFiscal
      }),
      this.EmpresaInformacionPrincipalService.get(this.empresaId).then((response) => (this.data = response.data)),
    ])
  }

  filtarRegimen(rfc) {
    this.regimenFiscal = rfc.length === 12 ? this.regimenCopia.filter(item => item.moral) : this.regimenCopia.filter(item => item.fisica)
  }

  cerrar(data) {
    if (data.actualizado) {
      this.aceptar = false
      this.form.$setPristine()
    }
    this.aceptar = false
  }
}

module.component('empresaInformacionPrincipal', {
  controller: EmpresaInformacionPrincipalComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/informacion/principal/component.js